
import * as React from 'react'
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './dialog'

interface DialogWrapperProps {
  children: React.ReactNode
  title?: string
  description?: string
  showCloseButton?: boolean
  size?: 'sm' | 'md' | 'lg' | 'xl'
  overlayClassName?: string
  contentClassName?: string
  open?: boolean
  onOpenChange?: (open: boolean) => void
}

const DialogWrapper = ({
  children,
  title,
  description,
  showCloseButton = true,
  size = 'md',
  overlayClassName: _overlayClassName,
  contentClassName,
  open,
  onOpenChange,
}: DialogWrapperProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      size={size}
      showCloseButton={showCloseButton}
      className={contentClassName}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      {description && <DialogDescription>{description}</DialogDescription>}
      {children}
    </DialogContent>
  </Dialog>
)

DialogWrapper.displayName = 'DialogWrapper'

export { DialogWrapper as Dialog }

// Re-export individual components for advanced usage
// DialogRoot = the raw Radix Dialog (not the wrapper)
export {
  DialogContent,
  DialogTitle,
  DialogDescription,
  DialogHeader,
  DialogFooter,
  DialogTrigger,
  DialogClose,
} from './dialog'

// Named re-export to avoid collision with DialogWrapper alias
export { Dialog as DialogRoot } from './dialog'
